import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { WPO_UNLOCK_COUNSELLOR } from '../../../../state/mutations/User';
import { captureException } from '@sentry/react-native';
import { client } from '../../../../config/apollo/client';
import { getAnswerByKey, unwrapMeta } from '../../utils';
import { observer } from 'mobx-react';
import { useOnAction } from '../../../../hooks/useOnAction';
import { useStores } from '../../../../hooks/useStores';

interface UnlockArgs {
  fromTime: string;
  toTime: string;
  timeZone?: string;
}
const unlockCounsellor = async (input: UnlockArgs) => {
  try {
    await client.mutate({
      mutation: WPO_UNLOCK_COUNSELLOR,
      variables: {input},
      fetchPolicy: 'no-cache',
    });
  } catch (err) {
    console.error(err);
    captureException(err);
  }
};

const _ContainConfirmSession: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
  onNext
}) => {

  const { treeNav } = useStores();

  // unlock if user navigates backward
  // TODO unlock if user closes survey
  // mobx complains with a warning about attaching listeners to non-root node
  // but this may be fixed in a later version of mobx
  useOnAction({
    target: treeNav,
    cb: call => {
      if (call.name === 'moveBack' && treeNav.nav?.current === 'confirmSession') {
        const confirm = getAnswerByKey('confirm', question.answers || []);
        const {
          fromTime,
          toTime,
        } = unwrapMeta(['title', 'picture', 'date', 'fromTime', 'toTime'], confirm);
        if (fromTime && toTime) {
          void unlockCounsellor({fromTime, toTime});
        } else {
          console.error('Missing fromTime and toTime to unlock appointment');
        }
      }
    }
  });

  return children({
    questionId: question._id,
    questionKey: question.key,
    answers: question.answers,
    onPress,
    onNext,
  });
};


export const ContainConfirmSession = observer(_ContainConfirmSession);
